export default function format(str) {
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  return [].concat(args).reduce(function (p, c) {
    return p.replace(/%s/, c);
  }, str);
}


//////////////////
// WEBPACK FOOTER
// ./~/@popperjs/core/lib/utils/format.js
// module id = 0F5E
// module chunks = 1